import PropTypes from 'prop-types';
import React from 'react';

import i18n from 'i18next';
import { withTranslation } from 'react-i18next';

import ResponsiveTable from '../../../nacre/components/responsiveTable';
import { Checkbox, Icon, Table } from 'semantic-ui-react';

class AttendeesTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sorted: 'order__sold_date',
            sortDirection: 'descending'
        };
    }

    componentDidMount() {
        this.props.addScrollListener();
    }

    componentWillUnmount() {
        this.props.removeScrollListener();
    }

    /**
     * Format order date with event timezone and organizer language
     */

    formatDate(dateString) {
        let date = new Date(dateString);
        date = date.toLocaleDateString(i18n.language, {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            timeZone: this.props.event.timezone
        });
        return date;
    }

    sort(spec) {
        if (!spec.sortKey) {
            return;
        }

        let direction;
        if (this.state.sorted === spec.sortKey) {
            if (this.state.sortDirection === 'ascending') {
                direction = 'descending';
            } else {
                direction = 'ascending';
            }
        } else {
            direction = 'ascending';
        }

        let descending = direction === 'descending';

        this.props.getAllAttendees({
            ordering: [`${descending ? '-' : ''}${spec.sortKey}`]
        });
        this.setState({
            sorted: spec.sortKey,
            sortDirection: direction
        });
    }

    /**
     * Render attendees table headers
     */
    renderAttendeesHeader() {
        const { t } = this.props;
        let headers = [
            {
                title: t('attendees.table.select'),
                sortKey: null
            },
            {
                title: t('attendees.table.origin'),
                sortKey: 'order__origin'
            },
            {
                title: t('attendees.table.orderDate'),
                sortKey: 'order__sold_date'
            },
            {
                title: t('attendees.table.name'),
                sortKey: 'first_name'
            },
            {
                title: t('attendees.table.lastname'),
                sortKey: 'last_name'
            },
            {
                title: t('attendee.info.rate'),
                sortKey: 'rate'
            },
            {
                title: t('attendees.table.orderReference'),
                sortKey: 'order__reference'
            },
            {
                title: t('attendees.table.validated'),
                sortKey: 'scan_status'
            }
        ];

        let cells = headers.map((header, index) => (
            <Table.HeaderCell key={`attendee-header-${index}`} sorted={header.sortKey === this.state.sorted ? this.state.sortDirection : null} onClick={() => this.sort(header)}>
                {header.title}
            </Table.HeaderCell>
        ));

        return <Table.Row>{cells}</Table.Row>;
    }

    /**
     * Render users returned from API
     */
    renderAttendeesList() {
        return this.props.attendees.map((user, index) => this.renderAttendeeItem(user, index));
    }

    /**
     * Render a single user item for the list
     */
    renderAttendeeItem(attendee, index) {
        const { t } = this.props;

        // selector | date | name | firstName | ticket | order | validated | paid
        let selected = !!this.props.selectedAttendees.find(sattendee => sattendee.id === attendee.id);
        let rate = this.props.rates.find(rate => +rate.id === +attendee.rate);

        return (
            <Table.Row key={attendee.id} className="attendee-row" onClick={() => this.props.onAttendeeClick(attendee.id)}>
                <Table.Cell>
                    <Checkbox checked={selected} onChange={(event, data) => this.props.onAttendeeSelected({ event, data }, attendee, index)} />
                </Table.Cell>
                <Table.Cell>{t(`attendees.table.originLabel.${attendee.order.origin}`) || '-'}</Table.Cell>
                <Table.Cell>{this.formatDate(attendee.order.sold_date)}</Table.Cell>
                <Table.Cell>{attendee.first_name}</Table.Cell>
                <Table.Cell>{attendee.last_name}</Table.Cell>
                <Table.Cell>{rate ? rate.name : '-'}</Table.Cell>
                <Table.Cell>{attendee.order.transaction_reference || '-'}</Table.Cell>
                <Table.Cell>
                    <Icon size="big" name="qrcode" color={attendee.scanned ? 'green' : 'grey'} />
                </Table.Cell>
            </Table.Row>
        );
    }

    render() {
        return (
            <ResponsiveTable sortable celled>
                <Table.Header>{this.renderAttendeesHeader()}</Table.Header>
                <Table.Body>{this.renderAttendeesList()}</Table.Body>
            </ResponsiveTable>
        );
    }
}

AttendeesTable.defaultProps = {
    rates: []
};

AttendeesTable.propTypes = {
    attendees: PropTypes.array.isRequired,
    addScrollListener: PropTypes.func.isRequired,
    event: PropTypes.object.isRequired,
    getAllAttendees: PropTypes.func.isRequired,
    onAttendeeClick: PropTypes.func.isRequired,
    onAttendeeSelected: PropTypes.func.isRequired,
    removeScrollListener: PropTypes.func.isRequired,
    selectedAttendees: PropTypes.array.isRequired,
    rates: PropTypes.array,
    t: PropTypes.func.isRequired
};

export default withTranslation()(AttendeesTable);
